import { useState } from 'react'
import Select from 'react-select'
import CloseIcon from '../../../assets/CloseIcon'
import SearchIcon from '../../../assets/SearchIcon'
import SalesOnlineOfflineFilter from './SalesOnlineOfflineFilter'

const LIMIT_OPTIONS = [
  { value: 50, label: '50' },
  { value: 100, label: '100' },
  { value: 150, label: '150' },
  { value: 200, label: '200' },
  { value: 250, label: '250' },
  { value: 300, label: '300' },
]

// const TIME_PERIOD_OPTIONS = [
//   { value: null, label: 'None' },
//   { value: 7, label: 'Last Week' },
//   { value: 30, label: 'Last Month' },
//   { value: 90, label: 'Last 3 Months' },
//   { value: 180, label: 'Last 6 Months' },
//   { value: 365, label: 'Last 1 Year' },
//   { value: 730, label: 'Last 2 Years' },
// ]

const SaleFilterOptions = ({
  filterOptions,
  updateFilterOptions,
}) => {
  const [searchTerm, setSearchTerm] = useState(
    filterOptions?.invoice_number || ''
  )

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    updateFilterOptions({ invoice_number: searchTerm })
  }

  const handleClearSearch = (e) => {
    e.preventDefault()
    if (!searchTerm) return
    setSearchTerm('')
    updateFilterOptions({ invoice_number: '' })
  }

  const handleLimitChange = (option) => {
    updateFilterOptions({ limit: option?.value })
  }

  const handleTypeChange = (type) => {
    updateFilterOptions({ type })
  }

  return (
    <div className="dFlex mt-5 gap-7">
      <div className={'formGroup mb-0 searchBar expand'}>
        <form onSubmit={handleSearchSubmit}>
          <input
            type="text"
            className="formControl"
            value={searchTerm}
            placeholder="Search By Invoice Number"
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearchSubmit(e)
              }
            }}
          />
        </form>
        <div className={`searchIcon`} onClick={handleSearchSubmit}>
          <SearchIcon />
        </div>
        <div className="closeIcon" onClick={handleClearSearch}>
          <CloseIcon />
        </div>
      </div>
      <div className="dFlex aiCenter">
        <span>Limit:</span>
        <Select
          className="formSelect reactSelect"
          options={LIMIT_OPTIONS}
          styles={{
            control: (base) => ({
              border: 0,
              display: 'flex',
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isFocused
                ? 'rgb(222, 235, 255)'
                : state.isSelected
                  ? '#FFF'
                  : 'inherit',
              color: '#212529',
              '&:hover': {
                backgroundColor: state.isSelected
                  ? '#DEEBFF'
                  : 'rgb(222, 235, 255)',
              },
            }),
          }}
          placeholder="Limit"
          value={LIMIT_OPTIONS.find(
            (option) => option.value === filterOptions?.limit
          )}
          onChange={handleLimitChange}
        />
      </div>

      <div className="dFlex aiCente ">
        <SalesOnlineOfflineFilter
          onFilterChange={handleTypeChange}
          currentType={filterOptions?.type || ''}
        />
      </div>
    </div>
  )
}

export default SaleFilterOptions
